export function changeQueryString(props, queryParams) {
  return props.history.push({
    search: "?" + new URLSearchParams(queryParams).toString(),
  });
}

export function getQueryStringToObject(queryString) {
  const urlParams = new URLSearchParams(queryString);
  const paramsObject = Object.fromEntries(urlParams);
  return paramsObject;
}

export function setQueryString(props, object, silent = false) {
  const search = props.location ? props.location.search : "";
  const urlParams = new URLSearchParams(search);
  for (const key in object) {
    if (object[key] === null || object[key] === undefined) {
      urlParams.delete(key);
    } else {
      urlParams.set(key, object[key]);
    }
  }

  if (silent) {
    return urlParams.toString();
  } else {
    props.history.replace(`?${urlParams.toString()}`);
  }
}
